/** Word-level IPA overrides for Dutch. */
export const nl: Record<string, string> = {
  aandelen: '/ˈaːndələn/',
  achterhaalt: '/ˈɑxtərhaːlt/',
  ademde: '/ˈaːdəmdə/', // past tense: breathed
  alchemie: '/ɑlxəˈmi/',
  allen: '/ˈɑlən/',
  alsoo: '/ɑlˈsoː/', // archaic: thus
  Anton: '/ˈɑntɔn/', // proper name
  balkons: '/bɑlˈkɔns/',
  bange: '/ˈbɑŋə/',
  benaeuwde: '/bəˈnaːudə/', // archaic: oppressed
  // New sample overrides
  benoemd: '/bəˈnuːmt/',
  bevonden: '/bəˈvɔndən/',
  bleeke: '/ˈbleːkə/', // archaic: pale
  bloedroze: '/ˈbludˌroːzə/',
  boomen: '/ˈboːmən/', // archaic: bomen (trees)
  braamstoelen: '/ˈbraːmˌstuːlən/', // blackberry bushes
  bureautje: '/byˈroːtjə/',
  burgery: '/bʏrɣəˈrɛi/', // archaic: burgerij
  dagelix: '/ˈdaːɣəlɪks/', // archaic: dagelijks
  dagschemer: '/ˈdɑɣˌsxeːmər/',
  dengenen: '/dɛnˈɣeːnən/', // archaic: those
  dese: '/ˈdeːzə/', // archaic: deze
  deselve: '/dəˈzɛlvə/', // archaic: dezelfde
  dien: '/diːn/', // archaic dative: that
  draaide: '/ˈdraːidə/',
  duitsen: '/ˈdœytsən/', // archaic: German
  eenvouds: '/ˈeːnvɑuts/', // archaic: simplicity
  eert: '/eːrt/',
  egters: '/ˈɛɣtərs/', // proper name
  engelen: '/ˈɛŋələn/',
  erbarremt: '/ɛrˈbɑrəmt/', // archaic: have mercy
  erembodegem: '/ˈeːrəmˌboːdɛɣəm/',
  erkers: '/ˈɛrkərs/',
  flauwe: '/ˈflɑuə/',
  frits: '/frɪts/',
  gekend: '/ɣəˈkɛnt/', // past participle: known
  gekomen: '/ɣəˈkoːmən/',
  gekund: '/ɣəˈkʏnt/',
  gemeenschappelijks: '/ɣəˈmeːnsxɑpələks/', // archaic genitive
  geschrey: '/ɣəˈsxrɛi/', // archaic: outcry
  gestelt: '/ɣəˈstɛlt/', // archaic: placed
  geverfd: '/ɣəˈvɛrft/', // painted, dyed
  gewone: '/ɣəˈwoːnə/',
  ghewelt: '/ɣəˈwɛlt/', // archaic: violence
  godt: '/ɣɔt/', // archaic: God
  goedkope: '/ˈɣutkʰoːpə/',
  graaft: '/ɣraːft/',
  groeiden: '/ˈɣruːidən/',
  grooten: '/ˈɣroːtən/', // archaic: great
  Haarlem: '/ˈhaːrləm/', // city name
  had: '/hɑt/',
  hadden: '/ˈhɑdən/',
  hare: '/ˈhaːrə/', // archaic: her
  hele: '/ˈheːlə/',
  hemelsche: '/ˈheːməlsxə/', // archaic: heavenly
  henri: '/ɑ̃ˈri/', // French name
  herinner: '/hɛˈrɪnər/',
  hispanje: '/hɪsˈpɑɲə/', // archaic: Spain
  hooft: '/hoːft/', // archaic: hoofd
  hooren: '/ˈhoːrən/', // archaic: horen
  immense: '/ɪˈmɛnsə/',
  inni: '/ˈɪni/', // proper name (Mulisch)
  kapellekensbaan: '/kaˈpɛləkənsˌbaːn/',
  kennelick: '/ˈkɛnələk/', // archaic: evident
  kraanwagentje: '/ˈkraːnˌwaːɣəntjə/',
  laatsten: '/ˈlaːtstən/',
  lande: '/ˈlɑndə/', // archaic dative: land
  lauriergracht: '/lɑuˈriːrɣrɑxt/',
  lesen: '/ˈleːzən/', // archaic: lezen
  lesten: '/ˈlɛstən/', // archaic: last
  louterende: '/ˈlɑutərɛndə/',
  mooiste: '/ˈmoːistə/', // superlative: prettiest
  my: '/mɛi/', // archaic: mij
  nassouwe: '/nɑˈsɑuə/', // archaic: Nassau
  niemandsbos: '/ˈniːmɑntsˌbɔs/', // nobody's forest
  oeroeg: '/ˈuruɣ/', // proper name (Haasse)
  ondersaten: '/ˈɔndərˌzaːtən/', // archaic: subjects
  ontwaakte: '/ɔntˈwaːktə/',
  onverveerd: '/ˌɔnvərˈveːrt/',
  opgerezen: '/ˈɔpɣəˌreːzən/',
  osewoudt: '/ˈoːzəˌwɑut/', // proper name (Hermans)
  ouders: '/ˈɑudərs/',
  philips: '/ˈfilɪps/',
  plachten: '/ˈplɑxtən/', // archaic: used to
  pleegde: '/ˈpleːɣdə/',
  poëtische: '/poˈeːtɪsxə/',
  prince: '/ˈprɪnsə/', // archaic: prins
  prinse: '/ˈprɪnsə/', // archaic variant
  reed: '/reːt/',
  romans: '/roˈmɑns/',
  saluyt: '/saːˈlœyt/', // archaic: greeting
  sarphatistraat: '/sɑrˈfaːtistraːt/', // street name (Nescio)
  scherpste: '/ˈsxɛrpstə/',
  schilderskade: '/ˈsxɪldərsˌkaːdə/', // street name
  Seynaeve: '/ˈsɛinaːvə/', // Belgian proper name
  sien: '/siːn/', // archaic: zien
  smalle: '/ˈsmɑlə/', // inflected: narrow
  spoorwegzate: '/ˈspoːrˌwɛxzaːtə/', // archaic: railway junction
  Steenwijk: '/ˈsteːnʋɛik/', // place name
  stonden: '/ˈstɔndən/',
  stopte: '/ˈstɔptə/',
  tamarindeboomen: '/taːmaːˈrɪndəˌboːmən/', // archaic: tamarind trees
  tegenwoordighe: '/ˈteːɣənˌwoːrdəɣə/', // archaic
  terechtgekomen: '/təˈrɛxtɣəˌkoːmən/',
  termurenlaan: '/tɛrˈmyːrənˌlaːn/',
  terugdenk: '/təˈrʏxdɛŋk/', // compound: think back
  torentjes: '/ˈtoːrəntjəs/',
  toverplaatjes: '/ˈtoːvərˌplaːtjəs/', // magic pictures
  tracht: '/trɑxt/', // verb: try
  tragische: '/ˈtraːɣɪsxə/',
  tusschen: '/ˈtʏsxən/', // archaic: tussen (between)
  velden: '/ˈvɛldən/',
  vermoordde: '/vərˈmoːrdə/',
  verschijnt: '/vərˈsxɛint/', // appears
  vlamde: '/ˈvlɑmdə/',
  vloog: '/vloːx/',
  volcx: '/vɔlks/', // archaic: volks

  volle: '/ˈvɔlə/',
  voorschoten: '/ˈvoːrsxoːtən/', // place name
  voorzomermiddag: '/ˈvoːrˌzoːmərˌmɪdɑx/',
  vroege: '/ˈvruɣə/',
  warme: '/ˈvɑrmə/',
  weerd: '/weːrt/', // archaic: waard
  weggegaan: '/ˈvɛxɣəˌɣaːn/',
  werd: '/wɛrt/',
  werkmenschen: '/ˈwɛrkˌmɛnsxən/', // archaic: working people
  'west-java': '/ˌwɛstˈjaːva/',
  wintrop: '/ˈvɪntrɔp/', // proper name (Mulisch)
  wonderlijker: '/ˈʋɔndərlɛikər/', // comparative: more wonderful
  woonde: '/ˈwoːndə/',
  wordt: '/wɔrt/',
  yegelick: '/ˈjeːɣəlɪk/', // archaic: iedereen
  zakkende: '/ˈzɑkəndə/', // sinking
  zekere: '/ˈzeːkərə/', // a certain
  zijne: '/ˈzɛinə/', // archaic: zijn
  zocht: '/zɔxt/',
  zuivere: '/ˈzœyvərə/', // pure (inflected)
  zulke: '/ˈzʏlkə/',
};
